module.exports = __webpack_public_path__ + "static/img/KOBY-LECRAS.c002ba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KOBY-LECRAS.jpg
// module id = /1JB
// module chunks = 0